import React, { useState, } from 'react'
import { Alert, Card, CardBody, Col, Input, Button, Row, Table } from 'reactstrap'
import FalconCardHeader from '../common/FalconCardHeader'
import FullPagination from '../common/pagination/FullPagination'
import PropTypes from 'prop-types'
import useSWRFetchPagination from '../../helpers/hooks/useSWRFetchPagination'
import { fetchBanks, remove } from '../../helpers/api/banks'
import { isIterableArray } from '../../helpers/utils'
import { SUCCESS_RESPONSE } from '../../helpers/codeResponses/codes'
import { Toast } from './../UI/toast/Toast'
import withRedirect from '../../helpers/hoc/withRedirect'
import handleErrorMessage from '../../helpers/errors/handleErrorMessage'
import BankListItem from '../common/BankListItem'
import { useSelector } from 'react-redux'
import { Message, Or, PreloadState } from "../UI/preloading/PreloadState";
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons'

const BanksList = ({ setRedirectUrl, setRedirect, title = 'Listado de bancos', showPagination }) => {

    const { role } = useSelector(state => state.auth.user);
    const [textSearch, setTextSearch] = useState('');
    const [params, setParams] = useState({
        search: null
    });
    const {
        data,
        error,
        isLoading,
        mutate,
        meta,
        handler: { nextPage, previousPage, perPage, goToPage }
    } = useSWRFetchPagination(fetchBanks, params);

    const handleDelete = async (toDeleteId) => {
        try {
            const res = await remove(toDeleteId);
            if (res.code === SUCCESS_RESPONSE.OK) {
                mutate()
                Toast.fire({
                    type: 'success',
                    title: `Se ha eliminado el banco satisfactoriamente.`,
                });
            }
        } catch (error) {
            handleErrorMessage(error);
        }
    }

    const handleEdit = ({ toEditId }) => {
        setRedirectUrl(`/dashboard/banks/edit/${toEditId}`);
        setRedirect(true);
    }

    const renderBankItems = (data) => data.map((bank, i) =>
        <BankListItem
            key={i}
            title={bank.name}
            toEditId={bank.bank_id}
            toDeleteId={bank?.condominiums?.[0]?.condominium_banks_id}
            onDeleteAction={({ toDeleteId }) => handleDelete(toDeleteId)}
            onEditAction={handleEdit}
            createdAt={bank.created_at}
            alternativeName="banco"
            options={true}
            owner_name={bank.owner_name}
            currency={bank.currency}
            owner_dni={bank.owner_dni}
            account_number={bank.account_number}
            mutate={mutate}
        />);

    return <>
        <Card>
            <FalconCardHeader title={title}>
                <Row>
                    <Col className="d-flex">
                        <Input
                            type='text'
                            value={textSearch}

                            onKeyDown={(e) => {
                                if (e.key !== 'Enter') return;
                                const value = e.currentTarget.value.trim();
                                setTextSearch(value);
                                setParams((rest) => ({ ...rest, search: value || null }));
                            }}
                            onChange={(event) => {
                                const value = event.target.value;
                                setTextSearch(value);
                                if (value.trim() === '') setParams((rest) => ({ ...rest, search: null }));
                            }} placeholder="Nombre, cuenta, titular, cédula, correo o moneda..." className="d-inline-block search-input mr-2" />
                        <Button className='d-inline-block' onClick={() => {
                            const value = textSearch.trim();
                            setTextSearch(value);
                            setParams((rest) => ({ ...rest, search: value || null }));
                        }} >Buscar</Button>
                    </Col>
                </Row>
            </FalconCardHeader>
            <CardBody className="fs--1">
                <PreloadState cond={isIterableArray(data)} loading={isLoading}>
                    <Or value={true}>
                        <Table responsive striped>
                            <thead>
                                <tr>
                                    <th>DNI</th>
                                    <th>Banco</th>
                                    <th weigth='25%'>Titular</th>
                                    <th>Moneda</th>
                                    <th weigth='25%'>Número de cuenta</th>
                                    <th>Creado el</th>
                                    {role === 'manager' && <th weigth='10%' className='text-center'>Opciones</th>}
                                </tr>
                            </thead>
                            <tbody>
                                {renderBankItems(data)}
                            </tbody>
                        </Table>
                    </Or>
                    <Or value={false} cond={!!error}>
                        <Or value={false} cond={role}>
                            <Or value={'manager'} cond={!!textSearch[0]}>
                                <Message value={true} color={'info'} className='p-3' align='left' icon={faInfoCircle}>
                                    <>
                                        No hemos encontrado un banco que coincida con <b>"{textSearch}"</b>.
                                    </>
                                </Message>
                                <Message value={false} color={'info'} className='p-3' align='left' icon={faInfoCircle}>
                                    No hay bancos registrados,
                                    Puedes crear uno en la sección de bancos del condominio.
                                </Message>
                            </Or>
                            <Or value={'property'} cond={!!textSearch[0]}>
                                <Message value={true} color={'info'} className='p-3' align='left' icon={faInfoCircle}>
                                    <>No hemos encontrado un banco que coincida con <b>"{textSearch}"</b></>
                                </Message>
                                <Message value={false} color={'info'} className='p-3' align='left' icon={faInfoCircle}>
                                    Al parecer aún no hay bancos en este condominio.
                                </Message>
                            </Or>
                        </Or>
                        <Or value={true}>
                            <Alert color="danger" className="mb-0">
                                Esta página no está disponible
                                <Button data-testid="Button" color="link" size="sm" className="ml-1 pl-0" onClick={() => { setRedirectUrl(`/dashboard/banks`); setRedirect(true) }}>
                                    Volver
                                </Button>
                            </Alert>
                        </Or>
                    </Or>
                </PreloadState>
            </CardBody>
            {isIterableArray(data) &&
                <CardBody>
                    <FullPagination
                        nextPage={nextPage}
                        prevPage={previousPage}
                        goToPage={goToPage}
                        meta={meta}
                        className={'shadow-none'}
                        posText={"bancos"}
                        perPage={perPage} />
                </CardBody>}
        </Card>
    </>
}

BanksList.propTypes = {
    showPagination: PropTypes.bool
};

export default withRedirect(BanksList);